module.exports = __webpack_public_path__ + "static/img/logo_ni.dba2cd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_ni.png
// module id = 8T+a
// module chunks = 1